
<div class="cust-clss"><div class="modal-body" style="padding: 8px 15px 10px 10px !important;">
    <h4 class="modal-title" >{{ data.title }}</h4>

    <p> {{ data.message }}</p>
    <div *ngIf="data.status != 1">
        <mat-form-field appearance="outline" style="width: 100%">
          <mat-label>Notes</mat-label>
          <textarea [(ngModel)]="note" matInput></textarea>
          <!-- <mat-icon matSuffix class="material-icons-outlined">message</mat-icon> -->
        </mat-form-field>
      </div>
</div>
<div class="modal-footer" style="justify-content: right !important;padding-right: 15px;" *ngIf="data.type == 'confirm'">
  
    <button mat-button (click)="dismiss()" style="margin-right: 10px;">{{ data.cancelbtn }}</button>
    <button mat-flat-button color="accent" *ngIf="data.type != 'success'" (click)="accept()">{{ data.okbtn }}</button>
 
</div>
</div>